<template>
  <div class="content-wrapper">
    <div class="card card-with-search border-0 card-with-shadow">
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <div class="row">
              <!-- <div class="col-lg-4 col-md-4 col-sm-4">
                <h1>{{ company.company_name }}</h1>
              </div> -->
              <div class="col-lg-4 col-md-4 col-sm-4">
                <h4 class="font-weight-bold">{{ company.company_name }}</h4>
                <p>({{ company.category.title }})</p>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-4">
                <!-- <button class="btn btn-primary">Short List</button> -->
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12">
                <p class="font-weight-bold">About</p>
                <p>
                  {{ company.description != null ? company.description : '-----' }}
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-6">
                    <div>
                      <p class="font-weight-bold mb-0">Email</p>
                      <p>{{ company.company_email }}</p>
                    </div>
                    <div>
                      <p class="font-weight-bold mb-0">Number</p>
                      <p>{{ company.company_phone }}</p>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6">
                    <div>
                      <p class="font-weight-bold mb-0">Postal Code</p>
                      <p>{{ company.postal_code }}</p>
                    </div>
                    <div>
                      <p class="font-weight-bold mb-0">Location</p>
                      <p>{{ company.address }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-12">
                <img src="" alt="" />
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12">
                <p class="font-weight-bold">Services</p>
                <ul v-if="company.services.length > 0" style="list-style: disc;">
                  <li v-for="(service, index) in company.services" :key="index">
                    {{service.name}}
                  </li>
                </ul>
                <p v-else>No Service</p>

              </div>
            </div>
            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12">
                <p class="font-weight-bold">Work Experience</p>
                <table class="table">
                  <tr>
                    <th>S.No</th>
                    <th>Certificate Title</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Action</th>
                  </tr>
                  <tr v-if="certificates.length > 0" v-for="(certificate, index) in certificates" :key="index">
                    <td>{{++index}}</td>
                    <td>{{certificate.title}}</td>
                    <td>2021-05-04 07:00</td>
                    <td>2021-05-04 07:00</td>
                    <td>
                      <!-- <a :href="'/admin/certificate/view/'+certificate.id" target="blank">view</a> -->
                      <a class="text-primary cursor-pointer" @click.prevent="view(certificate.pivot.id)">view</a>
                    </td>
                  </tr>
                  <tr v-if="certificates.length == 0">
                    <td><p>No Certificate</p></td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12">
                <p class="font-weight-bold">Company History</p>
                <p>
                  A well-written company history can entice prospective
                  customers
                </p>
              </div>
            </div>
            <!-- <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12 text-center">
                <button class="btn btn-primary btn-lg">Download</button>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <certificate-view
      v-if="isCertificateViewModalActive"
      :company_certificate_id="companyCertificateId"
      :company_id="companyId"
      @close-modal="closeCertificateViewModal"
    />
  </div>
</template>

<script>
import { COMPANY_GET_DETAILS, CERTIFICATE_VIEW } from "../../../../../../Config/ApiUrl";
import { axiosGet } from "../../../../../../Helpers/AxiosHelper";
import AppLibrary from "../../../../../../Helpers/AppLibrary";
import { FormMixin } from "../../../../../../../core/mixins/form/FormMixin";

export default {
  name: "CompanyProfileView",
  extends: AppLibrary,
  mixins: FormMixin,

  data() {
    return {
      isCertificateViewModalActive: false,
      companyCertificateId: 0,
      companyId: 0,
      company: {},
      certificates: [],
    };
  },
  methods: {
    getCompanyDetails(id) {
      axiosGet(COMPANY_GET_DETAILS + "/" + id)
        .then((res) => {
          this.company = res.data;
          this.certificates = res.data.company_certificates;
        })
        .catch((error) => {
          
        });
    },
    view(id) {
      this.companyCertificateId = id;
      // this.companyId = this.$attrs['props'].company_id;
      // this.isCertificateViewModalActive = true;

      // Extract the protocol and host from the current URL
      const { protocol, host } = window.location;

// Create the base URL using the protocol and host
        const baseUrl = `${protocol}//${host}`;
        const route = CERTIFICATE_VIEW+'/'+this.companyCertificateId;
        const url = baseUrl + route;
        // Open a new tab with the URL
        window.open(url, '_blank');
    },
    closeCertificateViewModal() {
      this.companyCertificateId = 0;
      $("#certificate-view-Modal").modal("hide");
      this.isCertificateViewModalActive = false;
    },
    // getCompanyCertificate(id) {
    //   axiosGet(COMPANY_CERTIFICATE_LIST + "/" + id)
    //     .then((res) => {
    //       this.certificates = res.data;
    //     })
    //     .catch((error) => {
    //       
    //     });
    // },
  },
  mounted() {
    // let myLocation = location.href;
    // let split = myLocation.split("/");
    // let nSplit = split[7].split("?");
    let id = this.$attrs['props'].company_id;
    this.getCompanyDetails(id);
    // this.getCompanyCertificate(id);
  },
};
</script>
